<template>
  <v-dialog
    width="1000px"
    :value="showNewEditPlaceDialog"
    @input="closePlace"
    persistent
    scrollable
  >
    <v-card class="kbLight">
      <v-toolbar class="kbGold" dark text flat>
        <div class="text-h6">
          {{
            methodNewEditPlace === "edit"
              ? $t("general.editPlace")
              : methodNewEditPlace === "view"
              ? $t("general.viewPlace")
              : $t("general.newPlace")
          }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePlace">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="validPlace" ref="newEditPlaceForm" lazy-validation>
          <!-- row title Place information --->
          <v-row>
            <v-col cols="12" class="text-h6 kbDarkBlue--text">
              <h3 class="pt-5">{{ $t("general.infoPlace") }}</h3>
            </v-col>
          </v-row>
          <!-- row fields form -->
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        :label="$t('general.name')"
                        color="kbDarkBlue"
                        :rules="[rules.required]"
                        v-model="newEditPlaceObj.name"
                        :readonly="readonly"
                        autofocus
                      />
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete
                        :items="placeCategories"
                        color="kbDarkBlue"
                        :label="$t('general.categories')"
                        item-text="name"
                        item-value="id"
                        :readonly="readonly"
                        v-model="categories"
                        multiple
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-autocomplete
                        :items="placePreferences"
                        color="kbDarkBlue"
                        :label="$t('general.preferences')"
                        item-text="label"
                        item-value="id"
                        :readonly="readonly"
                        v-model="preferences"
                        multiple
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        :label="$t('general.description')"
                        color="kbDarkBlue"
                        v-model="newEditPlaceObj.description"
                        :readonly="readonly"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="4">
                      <CountryPhonePicker v-model="newEditPlaceObj.phone" />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.email')"
                        color="kbDarkBlue"
                        v-model="newEditPlaceObj.email"
                        :rules="[rules.email]"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.webSiteUrl')"
                        color="kbDarkBlue"
                        v-model="newEditPlaceObj.website"
                        :rules="[rules.url]"
                        :readonly="readonly"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <VueGoogleAutocomplete
                        class="google_autocomplete"
                        id="map"
                        classname="form-control"
                        :defaultAddress="defaultAddress"
                        :placeholder="$t('general.pleaseTypeLocation')"
                        @placechanged="getAddressData"
                        @change="onChangeAddres"
                        :country="['co', 'us']"
                        :readonly="readonly"
                      >
                      </VueGoogleAutocomplete>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.country')"
                        color="kbDarkBlue"
                        v-model="country"
                        :rules="[rules.required]"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.state')"
                        color="kbDarkBlue"
                        v-model="state"
                        :rules="[rules.required]"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.city')"
                        color="kbDarkBlue"
                        v-model="city"
                        :rules="[rules.required]"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        :label="$t('general.zipCode')"
                        color="kbDarkBlue"
                        v-model="zipcode"
                        :rules="[rules.zipCode]"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field :label="`${$t('general.placeRating')} (1-5)`"
                                    color="kbDarkBlue"
                                    v-model.number="newEditPlaceObj.placeRating"
                                    prepend-icon="mdi-star-half-full"
                                    type="number"
                      />
                    </v-col>

                    <v-col cols="4">
                      <v-text-field :label="`${$t('general.priceRating')} (1-4)`"
                                    color="kbDarkBlue"
                                    v-model.number="newEditPlaceObj.priceRating"
                                    prepend-icon="mdi-currency-usd"
                                    type="number"
                      />
                    </v-col>
                    <v-col cols="12">
                      <VenueTagsAutocomplete
                        v-model="newEditPlaceObj.tags"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <SocialNetworksPicker
                v-if="newEditPlaceObj.socialLinks === undefined"
                v-model="socialLinks"
                from="Place"
              />
              <SocialNetworksPicker
                v-else
                v-model="newEditPlaceObj.socialLinks"
                from="Place"
              />
            </v-col>

            <v-col cols="12">
              <contacts-picker
                v-if="newEditPlaceObj.contacts === undefined"
                v-model="contacts"
                from="Place"
                :readonly="readonly"
              />
              <contacts-picker
                v-else
                v-model="newEditPlaceObj.contacts"
                from="Place"
                :readonly="readonly"
              />
            </v-col>
            <v-col cols="12">
              <image-picker
                button-color="kbGold"
                v-if="newEditPlaceObj.coverImage === undefined"
                v-model="coverImage"
                :title="$t('general.cover')"
              />
              <image-picker
                button-color="kbGold"
                v-else
                v-model="newEditPlaceObj.coverImage"
                :title="$t('general.cover')"
              />
            </v-col>

            <v-col cols="12">
              <image-picker
                button-color="kbGold"
                v-if="newEditPlaceObj.images === undefined"
                v-model="images"
                :title="$tc('general.pictures', 1)"
              />
              <image-picker
                button-color="kbGold"
                v-else
                v-model="newEditPlaceObj.images"
                :title="$tc('general.pictures', 1)"
              />
            </v-col>

            <v-col cols="12">
              <v-col cols="12" class="text-h6 kbDarkBlue--text">
                <h3 class="pt-5">{{ $t("general.configPlace") }}</h3>
              </v-col>

              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <p
                        class="pt-3"
                        style="font-size: 15px; cursor: pointer; width: max-content"
                      >
                        {{ $t("general.isPlaceActive") }}
                      </p>
                      <v-switch
                        hide-details
                        :label="$t('general.active')"
                        color="kbDarkBlue"
                        v-model="newEditPlaceObj.active"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col
                      v-if="
                        methodNewEditPlace === 'new' ||
                          methodNewEditPlace === 'edit'
                      "
                      cols="12"
                      sm="6"
                    >
                      <v-checkbox
                        v-model="duplicateBool"
                        :label="$t('general.doYouWantDuplicate')"
                      ></v-checkbox>
                      <v-slider
                        v-if="duplicateBool"
                        v-model="duplicates"
                        :max="max"
                        :min="min"
                        color="kbDarkBlue"
                        prepend-icon="mdi-content-copy"
                        :readonly="readonly"
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="duplicates"
                            class="mt-0 pt-0"
                            single-line
                            type="number"
                            style="width: 40px"
                            :readonly="readonly"
                          />
                        </template>
                      </v-slider>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete :label="$t('general.timeZone')"
                                      :items="timeZones"
                                      item-text="label"
                                      return-object
                                      v-model="newEditPlaceObj.timeZone"
                                      :readonly="readonly"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-select
                                  v-model="newEditPlaceObj.currency"
                                  :items="currencies"
                                  :label="$t('general.eventCurrency')"
                                  :readonly="readonly"
                                  item-text="label"
                                  item-value="value"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="newEditPlaceObj.workingHours">
                      <v-row>
                        <template v-for="(day, index) in newEditPlaceObj.workingHours.days">
                          <v-col cols="12"
                                :key="index"
                                md="4"
                                sm="6">

                            <v-card>
                              <v-card-title>
                                {{ days[index].label }}
                              </v-card-title>
                              <v-card-text>
                                <div>
                                  <v-switch :label="$t('general.nonWorkingDay')"
                                            v-model="day.isClosed"
                                            style="display: inline-flex"
                                            :readonly="readonly"
                                  ></v-switch>
                                </div>

                                <div v-if="day.isClosed">
                                  <v-alert type="error"
                                          :value="true">
                                    {{$t('general.nonWorkingDay')}}
                                  </v-alert>
                                </div>

                                <div v-else-if="!day.schedules || day.schedules.length === 0">
                                  <v-alert type="info"
                                          :value="true">
                                    {{$t('general.allDay')}}
                                  </v-alert>
                                </div>

                                <div v-if="!day.isClosed">
                                  <div style="display: inline-flex; align-items: center"
                                      :key="`${day.code} + ${index2}`"
                                      v-for="(schedule, index2) in day.schedules">

                                    <v-text-field @click="openTimePicker(index, index2, 'from')"
                                                  v-model="schedule.from"
                                                  :label="$t('general.from')"
                                                  readonly
                                                  :rules="[
                                                    rules.required,
                                                    timeRules.checkHours(index2 > 0 ? day.schedules[index2 - 1].until : '00:00', schedule.from)
                                                  ]">
                                    </v-text-field>

                                    <v-text-field @click="openTimePicker(index, index2, 'until')"
                                                  class="pl-2"
                                                  v-model="schedule.until"
                                                  :label="$t('general.until')"
                                                  readonly
                                                  :rules="[
                                                    rules.required,
                                                    timeRules.checkHours(schedule.from, schedule.until)
                                                  ]">
                                    </v-text-field>

                                    <v-btn icon
                                          @click="removeSchedule(day, index2)"
                                          v-if="!readonly"
                                    >
                                      <v-icon>
                                        mdi-delete
                                      </v-icon>
                                    </v-btn>
                                  </div>
                                </div>
                              </v-card-text>

                              <v-divider/>

                              <v-card-actions class="justify-end" v-if="!readonly && !day.isClosed && day.schedules.length !== 4">
                                <v-btn @click="addSchedule(day)" text>
                                  {{$t('general.addSchedule')}}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </template>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-switch
                        hide-details
                        :label="$t('general.isThisPlaceRestaurant')"
                        color="kbDarkBlue"
                        v-model="newEditPlaceObj.isRestaurant"
                        :readonly="readonly"
                      />
                    </v-col>

                    <v-col cols="12" md="6" v-if="newEditPlaceObj.isRestaurant">
                      <v-autocomplete :label="$t('general.diningStyle')"
                                      :items="diningStyles"
                                      item-text="label"
                                      v-model="newEditPlaceObj.diningStyle"
                                      :readonly="readonly"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6" v-if="newEditPlaceObj.isRestaurant">
                      <v-text-field :label="$t('general.priceAverage')"
                                    v-model.number="newEditPlaceObj.priceAverage"
                                    prepend-icon="mdi-currency-usd"
                                    type="number"
                      />
                    </v-col>

                    <v-col cols="12" md="6" v-if="newEditPlaceObj.isRestaurant">
                        <v-select
                                  v-model="newEditPlaceObj.dressCode"
                                  :items="dressCodes"
                                  :label="$t('general.dressCode')"
                                  :readonly="readonly"
                                  item-text="label"
                                  item-value="value"
                                  multiple
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="newEditPlaceObj.isRestaurant">
                        <v-select
                                  v-model="newEditPlaceObj.acceptedPaymentMethods"
                                  :items="paymentMethods"
                                  :label="$t('general.acceptedPaymentMethods')"
                                  :readonly="readonly"
                                  item-text="label"
                                  item-value="value"
                                  multiple
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" v-if="newEditPlaceObj.isRestaurant">
                        <v-select
                                  v-model="newEditPlaceObj.parkingType"
                                  :items="parkingTypes"
                                  :label="$t('general.parkingType')"
                                  :readonly="readonly"
                                  item-text="label"
                                  item-value="value"
                                  multiple
                        ></v-select>
                    </v-col>

                    <template v-if="newEditPlaceObj.isRestaurant">
                      <v-col cols="12"
                        v-for="diningType in diningTypes"
                        :key="diningType"
                      >
                        <v-card>
                          <v-card-title>
                            {{$t(`general.${diningType}`)}}
                          </v-card-title>
                          <v-card-text>
                            <div style="display: inline-flex; align-items: center"
                              :key="`${index}`"
                              v-for="(schedule, index) in newEditPlaceObj[`${diningType}Schedules`]"
                            >
                              <v-select v-model="schedule.fromDay"
                                        :label="$t('general.from')"
                                        :items="days"
                                        item-text="label"
                                        item-value="value"
                                        class="mr-3"
                              ></v-select>
                              <v-select v-model="schedule.untilDay"
                                        color="kbDarkBlueText"
                                        :label="$t('general.until')"
                                        :items="days"
                                        item-text="label"
                                        item-value="value"
                                        class="mr-3"
                              ></v-select>

                              <v-text-field @click="openDiningTimePicker(diningType, index, 'fromTime')"
                                            v-model="schedule.fromTime"
                                            :label="$t('general.from')"
                                            readonly
                                            :rules="[
                                              rules.required
                                            ]">
                              </v-text-field>

                              <v-text-field @click="openDiningTimePicker(diningType, index, 'untilTime')"
                                            class="pl-2"
                                            v-model="schedule.untilTime"
                                            :label="$t('general.until')"
                                            readonly
                                            :rules="[
                                              rules.required,
                                              timeRules.checkHours(schedule.fromTime, schedule.untilTime)
                                            ]">
                              </v-text-field>

                              <v-btn icon
                                    @click="removeDiningSchedule(diningType, index)"
                                    v-if="!readonly"
                              >
                                <v-icon>
                                  mdi-delete
                                </v-icon>
                              </v-btn>
                            </div>
                          </v-card-text>

                          <v-divider/>

                          <v-card-actions class="justify-end" v-if="!readonly">
                            <v-btn @click="addDiningSchedule(diningType)" text>
                              {{$t('general.addSchedule')}}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </template>

                    <v-dialog @input="closeTimePicker()"
                              max-width="300px"
                              v-model="showTimePicker">
                      <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                          {{ days[selectedSchedule.day] && days[selectedSchedule.day].label }}
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-time-picker color="primary"
                                    format="24hr"
                                    style="border-radius: 0; box-shadow: none"
                                    v-if="showTimePicker"
                                    v-model="timePickerValue">
                        <v-spacer/>
                        <v-btn text
                              color="primary"
                              @click="closeTimePicker()">
                          {{$t('general.cancel')}}
                        </v-btn>

                        <v-btn text
                              color="primary"
                              @click="saveSchedule()">
                          {{$t('general.accept')}}
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>

                    <v-dialog @input="closeDiningTimePicker()"
                              max-width="300px"
                              v-model="showDiningTimePicker">
                      <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                          {{$t(`general.${selectedDiningSchedule.diningType}`)}}
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-time-picker color="primary"
                                    format="24hr"
                                    style="border-radius: 0; box-shadow: none"
                                    v-if="showDiningTimePicker"
                                    v-model="diningTimePickerValue">
                        <v-spacer/>
                        <v-btn text
                              color="primary"
                              @click="closeDiningTimePicker()">
                          {{$t('general.cancel')}}
                        </v-btn>

                        <v-btn text
                              color="primary"
                              @click="saveDiningSchedule()">
                          {{$t('general.accept')}}
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <template v-if="readonly">
          <v-btn color="kbGold" dark @click="closePlace">
            {{ $t("general.close") }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn class="mr-2" color="red" outlined @click="closePlace"
            >Cancelar</v-btn
          >
          <v-btn
            color="kbGold"
            dark
            @click="submit"
            :loading="loadingSubmitNewUpdatePlace"
          >
            {{
              methodNewEditPlace === "edit"
                ? $t("general.editPlace")
                : $t("general.newPlace")
            }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import timeZones from '@/libs/timeZones'
import transOfferings from '@/libs/eventPlaces/placesOfferings'
import transExperiences from '@/libs/eventPlaces/placesExperiences'
import transTypes from '@/libs/eventPlaces/placesTypes'
import ImagePicker from '@/pages/App/Events/dialogs/ImagePicker.vue'
import ContactsPicker from '@/pages/App/Events/dialogs/ContactsPicker.vue'
import SocialNetworksPicker from '@/pages/App/Events/dialogs/SocialNetworksPicker.vue'
import VueGoogleAutocomplete from '@/components/ui/VueGoogleAutocomplete.vue'
import VenueTagsAutocomplete from '@/components/ui/VenueTagsAutocomplete'
import CountryPhonePicker from '@/components/ui/CountryPhonePicker'
export default {
  components: {
    ContactsPicker,
    ImagePicker,
    SocialNetworksPicker,
    VueGoogleAutocomplete,
    VenueTagsAutocomplete,
    CountryPhonePicker
  },
  computed: {
    ...mapState({
      loadingSubmitNewUpdatePlace: state =>
        state.events.loadingSubmitNewUpdatePlace,
      methodNewEditPlace: state => state.events.methodNewEditPlace,
      placeCategories: state => state.events.placeCategories,
      placePreferences: state => state.events.placePreferences
    }),

    experiences () {
      return transExperiences()
    },

    offerings () {
      return transOfferings()
    },

    types () {
      return transTypes()
    },

    // Object that stores all the new Place info.
    newEditPlaceObj: {
      get () {
        return this.$store.state.events.newEditPlaceObj
      },
      set (value) {
        this.$store.commit('SET_NEW_EDIT_PLACE_OBJ', value)
      }
    },

    // Resets all CREATE or EDIT Place values.
    showNewEditPlaceDialog: {
      get () {
        return this.$store.state.events.showNewEditPlaceDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PLACE_DIALOG', value)
      }
    },

    // Returns true if we on view only mode.
    readonly () {
      return this.methodNewEditPlace === 'view'
    },

    days () {
      return [
        {
          label: this.$t('general.sunday'),
          value: 'sunday'
        },
        {
          label: this.$t('general.monday'),
          value: 'monday'
        },
        {
          label: this.$t('general.tuesday'),
          value: 'tuesday'
        },
        {
          label: this.$t('general.wednesday'),
          value: 'wednesday'
        },
        {
          label: this.$t('general.thursday'),
          value: 'thursday'
        },
        {
          label: this.$t('general.friday'),
          value: 'friday'
        },
        {
          label: this.$t('general.saturday'),
          value: 'saturday'
        },
        {
          label: this.$t('general.daily'),
          value: 'daily'
        }
      ]
    },
    dressCodes () {
      return [
        { label: this.$t('general.casual'), value: 'casual' },
        { label: this.$t('general.businessCasual'), value: 'businessCasual' },
        { label: this.$t('general.casualElegant'), value: 'casualElegant' },
        { label: this.$t('general.formal'), value: 'formal' },
        { label: this.$t('general.jacketRequired'), value: 'jacketRequired' },
        { label: this.$t('general.jacketAndTie'), value: 'jacketAndTie' }
      ]
    },
    paymentMethods () {
      return [
        { label: 'Cash', value: 'cash' },
        { label: 'Visa', value: 'visa' },
        { label: 'Marstercard', value: 'mastercard' },
        { label: 'American Express', value: 'americanExpress' },
        { label: 'Discover', value: 'discover' },
        { label: 'QR payment ', value: 'qrPayment' }
      ]
    },
    parkingTypes () {
      return [
        { label: 'Valet parking', value: 'valetParking' },
        { label: 'Street parking', value: 'streetParking' },
        { label: 'Public lot', value: 'publicLot' },
        { label: 'Free parking', value: 'freeParking' }
      ]
    }
  },
  data () {
    return {
      categories: [],
      preferences: [],
      validPlace: false,
      contacts: [],
      socialLinks: [],
      coverImage: '',
      images: [],
      rules,
      duplicates: 1,
      max: 30,
      min: 1,
      duplicateBool: false,
      city: '',
      state: '',
      country: '',
      zipcode: '',
      placeLocation: '',
      defaultAddress: '',
      showTimePicker: false,
      showDiningTimePicker: false,
      selectedSchedule: '',
      selectedDiningSchedule: '',
      timePickerValue: '',
      diningTimePickerValue: '',
      timeRules: {
        checkHours: (from, until) => {
          return this.isBefore(from, until) || `Debes elegir después de ${from}`
        }
      },
      diningStyles: [
        {
          label: 'Fine dining',
          value: 'fineDining'
        },
        {
          label: 'Casual dining',
          value: 'casualDining'
        },
        {
          label: 'Fast Casual',
          value: 'fastCasual'
        },
        {
          label: 'Buffet',
          value: 'buffet'
        },
        {
          label: 'Self service',
          value: 'selfService'
        },
        {
          label: 'Fast Food',
          value: 'fastFood'
        }
      ],
      diningTypes: [
        'brunch',
        'lunch',
        'happyHour',
        'dinner'
      ],
      currencies: [
        { label: 'COP', value: 'cop' },
        { label: 'USD', value: 'usd' }
      ],
      timeZones
    }
  },

  methods: {
    onChangeAddres (address) {
      this.placeLocation = address
    },
    getAddressData (addressData, placeResultData, id) {
      const getAddr = placeResultData.formatted_address.split(',')
      this.newEditPlaceObj.placeLocationUrl = placeResultData.url
      this.newEditPlaceObj.placeLocationReference = placeResultData.reference
      this.city = getAddr[1].substr(1)
      this.state = getAddr[2].substr(1)
      this.country = getAddr[3].substr(1)
    },

    // Dispatchs actions if methidNewEditPlace is New or Edit.
    async submit () {
      try {
        if (this.methodNewEditPlace === 'view') {
          this.showNewEditPlaceDialog = !this.showNewEditPlaceDialog
          return
        }
        if (await !this.$refs.newEditPlaceForm.validate()) { return notifications.error('Complete los campos requeridos') }
        if (!this.newEditPlaceObj.phone || !this.newEditPlaceObj.phone.valid) { return notifications.error('Complete el formulario con el teléfono') }

        // check schedule
        let badSchedule = false

        this.newEditPlaceObj.workingHours.days.forEach(day => {
          if (day.isClosed) return
          return day.schedules.forEach((schedule, index) => {
            if (!this.isBefore(index > 0 ? day.schedules[index - 1].until : '00:00', schedule.from)) badSchedule = true
            if (!this.isBefore(schedule.from, schedule.until)) badSchedule = true
          })
        })

        if (badSchedule) {
          return notifications.error('Revisa el horario de trabajo')
        }

        if (this.methodNewEditPlace === 'new') {
          if (this.newEditPlaceObj.contacts === undefined) { this.newEditPlaceObj.contacts = this.contacts }
          if (this.newEditPlaceObj.socialLinks === undefined) { this.newEditPlaceObj.socialLinks = this.socialLinks }
          if (this.newEditPlaceObj.coverImage === undefined) { this.newEditPlaceObj.coverImage = this.coverImage }
          if (this.newEditPlaceObj.images === undefined) { this.newEditPlaceObj.images = this.images }
          this.newEditPlaceObj.city = this.city
          this.newEditPlaceObj.state = this.state
          this.newEditPlaceObj.country = this.country
          this.newEditPlaceObj.zipcode = this.zipcode
          this.newEditPlaceObj.placeLocation = this.placeLocation
          this.newEditPlaceObj.categories = this.categories
          this.newEditPlaceObj.preferences = this.preferences
          const response = await this.$store.dispatch(
            'createPlace',
            this.duplicates
          )
          if (response) {
            notifications.success('Lugar creado correctamente')
            this.$store.dispatch('updateVenuesTags')
            this.resetNewPlace()
          }
        }
        if (this.methodNewEditPlace === 'edit') {
          if (this.newEditPlaceObj.contacts === undefined) { this.newEditPlaceObj.contacts = this.contacts }
          if (this.newEditPlaceObj.socialLinks === undefined) { this.newEditPlaceObj.socialLinks = this.socialLinks }
          if (this.newEditPlaceObj.coverImage === undefined) { this.newEditPlaceObj.coverImage = this.coverImage }
          if (this.newEditPlaceObj.images === undefined) { this.newEditPlaceObj.images = this.images }
          this.newEditPlaceObj.city = this.city
          this.newEditPlaceObj.state = this.state
          this.newEditPlaceObj.country = this.country
          this.newEditPlaceObj.placeLocation = this.placeLocation
          this.newEditPlaceObj.zipcode = this.zipcode
          this.newEditPlaceObj.categories = this.categories
          this.newEditPlaceObj.preferences = this.preferences

          // Checking if user selected to duplicate an already created place.
          if (this.duplicateBool) {
            const response = await this.$store.dispatch(
              'createPlace',
              this.duplicates
            )
            if (response) {
              notifications.success('Lugar creado correctamente')
              this.$store.dispatch('updateVenuesTags')
              this.resetNewPlace()
            }
          } else {
            const response = await this.$store.dispatch('updatePlace')
            if (response) {
              notifications.success('Lugar actualizado correctamente')
              this.$store.dispatch('updateVenuesTags')
              this.resetNewPlace()
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    },

    // Resets all CREATE or EDIT Place values.
    resetNewPlace () {
      this.$refs.newEditPlaceForm.reset()
      // this.images and this.coverImage persisted when Creating a new Place
      this.images = []
      this.coverImage = ''
      this.city = ''
      this.state = ''
      this.country = ''
      this.placeLocation = ''
      this.newEditPlaceObj.placeLocationUrl = ''
      this.newEditPlaceObj.placeLocation = ''
      this.showNewEditPlaceDialog = !this.showNewEditPlaceDialog
    },

    // Closes NewEditPlace Dialog without saving info.
    closePlace () {
      // This is highly inneficient, review later.
      this.$store.dispatch('getPlaces')
      this.duplicates = 1
      this.duplicateBool = false
      this.city = ''
      this.state = ''
      this.country = ''
      this.placeLocation = ''
      this.defaultAddress = ''
      this.newEditPlaceObj.placeLocationUrl = ''
      this.newEditPlaceObj.placeLocation = ''
      // Resetting default duplicates and duplicateBool values
      this.showNewEditPlaceDialog = !this.showNewEditPlaceDialog
    },

    isBefore (from, until) {
      if (!from || !until) return true
      const fromMoment = moment(from, 'HH:mm')
      const untilMoment = moment(until, 'HH:mm')
      return fromMoment.isBefore(untilMoment)
    },

    addSchedule (day) {
      if (!Array.isArray(day.schedules)) {
        this.$set(day, 'schedules', [])
        day.schedules.push({ from: '', until: '' })
        return
      }

      if (day.schedules.length === 4) return

      const backSchedule = day.schedules[day.schedules.length - 1]

      if (backSchedule && (!backSchedule.from || !backSchedule.until)) return
      day.schedules.push({ from: '', until: '' })
    },

    removeSchedule (day, index) {
      day.schedules.splice(index, 1)
    },

    openTimePicker (day, schedule, selection) {
      this.selectedSchedule = { day, schedule, selection }
      this.timePickerValue = this.newEditPlaceObj.workingHours.days[day].schedules[schedule][selection]
      this.showTimePicker = true
    },

    closeTimePicker () {
      this.showTimePicker = false
    },

    saveSchedule () {
      const v = this.selectedSchedule
      this.newEditPlaceObj.workingHours.days[v.day].schedules[v.schedule][v.selection] = this.timePickerValue
      this.showTimePicker = false
    },

    addDiningSchedule (diningType) {
      let schedules = this.newEditPlaceObj[`${diningType}Schedules`]
      if (!Array.isArray(schedules) || !schedules.length) {
        schedules = []
        schedules.push({ fromTime: '', untilTime: '', fromDay: '', untilDay: '' })
        this.$set(this.newEditPlaceObj, `${diningType}Schedules`, schedules)
        return
      }

      if (schedules.length === 4) return

      const backSchedule = schedules[schedules.length - 1]

      if (backSchedule && (!backSchedule.fromTime || !backSchedule.untilTime)) return
      schedules.push({ fromTime: '', untilTime: '', fromDay: '', untilDay: '' })
      this.$set(this.newEditPlaceObj, `${diningType}Schedules`, schedules)
    },

    removeDiningSchedule (diningType, index) {
      this.newEditPlaceObj[`${diningType}Schedules`].splice(index, 1)
    },

    openDiningTimePicker (diningType, schedule, selection) {
      this.selectedDiningSchedule = { diningType, schedule, selection }
      this.diningTimePickerValue = this.newEditPlaceObj[`${diningType}Schedules`][schedule][selection]
      this.showDiningTimePicker = true
    },

    closeDiningTimePicker () {
      this.showDiningTimePicker = false
    },

    saveDiningSchedule () {
      const v = this.selectedDiningSchedule
      this.newEditPlaceObj[`${v.diningType}Schedules`][v.schedule][v.selection] = this.diningTimePickerValue
      this.closeDiningTimePicker()
    }

  },
  watch: {
    showNewEditPlaceDialog: {
      handler (value) {
        if (
          this.methodNewEditPlace === 'edit' ||
          this.methodNewEditPlace === 'view'
        ) {
          this.city = this.newEditPlaceObj.city
          this.state = this.newEditPlaceObj.state
          this.country = this.newEditPlaceObj.country
          this.defaultAddress = this.newEditPlaceObj.placeLocation
          this.placeLocation = this.newEditPlaceObj.placeLocation
          this.zipcode = this.newEditPlaceObj.zipcode
          this.categories = this.newEditPlaceObj.categories
          this.preferences = this.newEditPlaceObj.preferences
        }
        if (!value) {
          this.newEditPlaceObj = {}
          this.city = ''
          this.state = ''
          this.country = ''
          this.zipcode = ''
          this.placeLocation = ''
          this.defaultAddress = ''
          this.categories = []
          this.preferences = []
        }
      },
      deep: true
    },
    newEditPlaceObj: {
      handler (value) {
        if (!value.workingHours || (Array.isArray(value.workingHours) && value.workingHours.length === 0)) {
          this.$set(this.newEditPlaceObj, 'workingHours', {
            blockMessageComposer: false,
            days: [
              { code: 0, isClosed: false, schedules: [] },
              { code: 1, isClosed: false, schedules: [] },
              { code: 2, isClosed: false, schedules: [] },
              { code: 3, isClosed: false, schedules: [] },
              { code: 4, isClosed: false, schedules: [] },
              { code: 5, isClosed: false, schedules: [] },
              { code: 6, isClosed: false, schedules: [] }
            ],
            enable: false,
            message: ''
          })
        }
        if (typeof value.phone === 'string') {
          this.$set(this.newEditPlaceObj, 'phone', {
            code: 'co',
            country: 'colombia',
            number: '57',
            phone: value.phone,
            valid: true
          })
        }
        if (value.contacts) {
          for (let i = 0; i < value.contacts.length; i++) {
            const contact = value.contacts[i]
            if (typeof contact.phone === 'string') {
              contact.phone = {
                code: 'co',
                country: 'colombia',
                number: '57',
                phone: contact.phone,
                valid: true
              }
            }
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.google_autocomplete {
  padding: 15px 0 15px 5px;
  width: 100%;
  border-bottom: 1px solid gray;
}
</style>
